// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    productId: string;
    qtyOrdered?: number;
    unitOfMeasure?: string;
}

type HandlerType = Handler<Parameter & HasOnSuccess<RealTimePricingModel> & HasOnError<unknown>>;

export const LoadRealTimePricing: HandlerType = async props => {
    if (!props.parameter.unitOfMeasure) {
        return;
    }

    const productParameter = {
        productId: props.parameter.productId,
        qtyOrdered: props.parameter.qtyOrdered ?? 1,
        unitOfMeasure: props.parameter.unitOfMeasure,
    };

    const awaitableLoadRealTimePricing = makeHandlerChainAwaitable<Parameters<typeof loadRealTimePricing>[0], RealTimePricingModel>(loadRealTimePricing);
    const realTimePricing = await awaitableLoadRealTimePricing({ productPriceParameters: [productParameter] })(props.dispatch, props.getState);

    if (realTimePricing) {
        props.parameter.onSuccess?.(realTimePricing);
    } else {
        props.parameter.onError?.(realTimePricing);
    }
};


export const chain = [LoadRealTimePricing];

const updateAutoCompleteProductInfo = createHandlerChainRunner(chain, "UpdateAutoCompleteProductInfo");

export default updateAutoCompleteProductInfo;
